import React from 'react';

import { Link as RouterLink } from "react-router-dom";
import { Link } from "@material-ui/core";

// Combines Link components from React Router and MUI
export const MuiRouterLink = React.forwardRef((props, ref) => {
  return <Link ref={ref} {...props} component={RouterLink}>{props.children}</Link>
})